<template>
  <div>
    <ca-row v-if="!event.defaultEvent">
      <ca-col>
        <ca-button
          class="ca-u-min-margin-right"
          @click="onEdit">
          Editar
        </ca-button>
        <ca-button
          @click="onDelete">
          Excluir
        </ca-button>
      </ca-col>
    </ca-row>

    <ca-row vertical-offset="2">
      <ca-col>
        <ca-page>
          <ca-async-content-wrapper
            :on-fetch="getEvent"
            :on-fetch-success="setEvent">
            <div v-if="event">
              <ca-row>
                <ca-col
                  v-for="(info, index) in data"
                  :key="index"
                  size="4">
                  <ca-field :label="info.label">
                    {{ info.value }}
                  </ca-field>
                </ca-col>
              </ca-row>
              <ca-row>
                <ca-col size="4">
                  <ca-field label="Eventos base">
                    <ca-table theme="simple">
                      <ca-tr slot="header">
                        <ca-th width="80px">Código</ca-th>
                        <ca-th>Descrição</ca-th>
                      </ca-tr>
                      <ca-tr
                        v-for="baseEvent in event.baseEvents"
                        :key="baseEvent.id">
                        <ca-td>{{ baseEvent.code }}</ca-td>
                        <ca-td>{{ baseEvent.description }}</ca-td>
                      </ca-tr>
                    </ca-table>
                  </ca-field>
                </ca-col>
              </ca-row>
            </div>
          </ca-async-content-wrapper>
        </ca-page>
      </ca-col>
    </ca-row>
  </div>
</template>

<script>
import { DELETE_MESSAGE, DELETE_TITLE } from './constants';
import { getEvent, mountViewInfo, deleteEvent } from './eventService';

export default {
  name: 'EventViewPage',
  data() {
    return {
      eventId: this.$route.params.id,
      event: {},
      data: null,
    };
  },
  methods: {
    getEvent() {
      return getEvent(this.eventId);
    },
    mountViewInfo,
    setEvent(event) {
      this.event = event;
      this.data = mountViewInfo(this.event);
    },
    onEdit() {
      this.$router.push({ name: 'EventEditForm', params: { id: this.eventId } });
    },
    onDelete() {
      this.$caConfirm({
        title: DELETE_TITLE,
        message: DELETE_MESSAGE,
        confirmButtonText: 'Excluir registro',
        onConfirm: () => {
          deleteEvent(this.eventId)
            .then(() => {
              this.$toaster.success('Evento excluído com sucesso.');
              this.$router.push({ name: 'EventsPage' });
            })
            .catch(() => {
              this.$toaster.error('Erro ao excluir evento');
            });
        },
      });
    },
  },
};
</script>
